// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-dialog {
  align-items: center;
  justify-content: center;
  margin: auto;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content {
  max-height: calc(100% - 48px);
  width: calc(100% - 48px);
  max-width: calc(100% - 48px);
  margin: 24px;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-sheet,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-sheet {
  --v-scrollbar-offset: 0px;
  border-radius: 4px;
  overflow-y: auto;
  flex: 1 1 var(--v-card-height, 100%);
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-sheet,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-sheet {
  box-shadow: 0px 11px 15px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 24px 38px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 46px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card {
  display: flex;
  flex-direction: column;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card > .v-card-item,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card > .v-card-item {
  padding: 16px 24px;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card > .v-card-item + .v-card-text,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card > .v-card-item + .v-card-text {
  padding-top: 0;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card > .v-card-text,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card > .v-card-text {
  font-size: inherit;
  letter-spacing: 0.03125em;
  line-height: inherit;
  padding: 16px 24px 24px;
}
:where(.vuetify-styles) .v-dialog > .v-overlay__content > .v-card > .v-card-actions,
:where(.vuetify-styles) .v-dialog > .v-overlay__content > form > .v-card > .v-card-actions {
  justify-content: flex-end;
}

:where(.vuetify-styles) .v-dialog--fullscreen {
  --v-scrollbar-offset: 0px;
}
:where(.vuetify-styles) .v-dialog--fullscreen > .v-overlay__content {
  border-radius: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  top: 0;
  left: 0;
}
:where(.vuetify-styles) .v-dialog--fullscreen > .v-overlay__content > .v-card,
:where(.vuetify-styles) .v-dialog--fullscreen > .v-overlay__content > .v-sheet,
:where(.vuetify-styles) .v-dialog--fullscreen > .v-overlay__content > form > .v-card,
:where(.vuetify-styles) .v-dialog--fullscreen > .v-overlay__content > form > .v-sheet {
  min-height: 100%;
  min-width: 100%;
  border-radius: 0;
}

:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > form,
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > form > .v-card {
  max-height: 100%;
  max-width: 100%;
}
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content,
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > .v-card,
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > form,
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > form > .v-card {
  display: flex;
  flex: 1 1 var(--v-card-height, 100%);
  flex-direction: column;
}
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > .v-card > .v-card-text,
:where(.vuetify-styles) .v-dialog--scrollable > .v-overlay__content > form > .v-card > .v-card-text {
  backface-visibility: hidden;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDialog/VDialog.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;AACd;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;;;;EAIE,4OAA4O;AAC9O;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;AACA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;EAIE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;AACA;;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".v-dialog {\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n.v-dialog > .v-overlay__content {\n  max-height: calc(100% - 48px);\n  width: calc(100% - 48px);\n  max-width: calc(100% - 48px);\n  margin: 24px;\n}\n.v-dialog > .v-overlay__content,\n.v-dialog > .v-overlay__content > form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.v-dialog > .v-overlay__content > .v-card,\n.v-dialog > .v-overlay__content > .v-sheet,\n.v-dialog > .v-overlay__content > form > .v-card,\n.v-dialog > .v-overlay__content > form > .v-sheet {\n  --v-scrollbar-offset: 0px;\n  border-radius: 4px;\n  overflow-y: auto;\n  flex: 1 1 var(--v-card-height, 100%);\n}\n.v-dialog > .v-overlay__content > .v-card,\n.v-dialog > .v-overlay__content > .v-sheet,\n.v-dialog > .v-overlay__content > form > .v-card,\n.v-dialog > .v-overlay__content > form > .v-sheet {\n  box-shadow: 0px 11px 15px -7px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 24px 38px 3px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 9px 46px 8px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-dialog > .v-overlay__content > .v-card,\n.v-dialog > .v-overlay__content > form > .v-card {\n  display: flex;\n  flex-direction: column;\n}\n.v-dialog > .v-overlay__content > .v-card > .v-card-item,\n.v-dialog > .v-overlay__content > form > .v-card > .v-card-item {\n  padding: 16px 24px;\n}\n.v-dialog > .v-overlay__content > .v-card > .v-card-item + .v-card-text,\n.v-dialog > .v-overlay__content > form > .v-card > .v-card-item + .v-card-text {\n  padding-top: 0;\n}\n.v-dialog > .v-overlay__content > .v-card > .v-card-text,\n.v-dialog > .v-overlay__content > form > .v-card > .v-card-text {\n  font-size: inherit;\n  letter-spacing: 0.03125em;\n  line-height: inherit;\n  padding: 16px 24px 24px;\n}\n.v-dialog > .v-overlay__content > .v-card > .v-card-actions,\n.v-dialog > .v-overlay__content > form > .v-card > .v-card-actions {\n  justify-content: flex-end;\n}\n\n.v-dialog--fullscreen {\n  --v-scrollbar-offset: 0px;\n}\n.v-dialog--fullscreen > .v-overlay__content {\n  border-radius: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  top: 0;\n  left: 0;\n}\n.v-dialog--fullscreen > .v-overlay__content > .v-card,\n.v-dialog--fullscreen > .v-overlay__content > .v-sheet,\n.v-dialog--fullscreen > .v-overlay__content > form > .v-card,\n.v-dialog--fullscreen > .v-overlay__content > form > .v-sheet {\n  min-height: 100%;\n  min-width: 100%;\n  border-radius: 0;\n}\n\n.v-dialog--scrollable > .v-overlay__content > form,\n.v-dialog--scrollable > .v-overlay__content > form > .v-card {\n  max-height: 100%;\n  max-width: 100%;\n}\n.v-dialog--scrollable > .v-overlay__content,\n.v-dialog--scrollable > .v-overlay__content > .v-card,\n.v-dialog--scrollable > .v-overlay__content > form,\n.v-dialog--scrollable > .v-overlay__content > form > .v-card {\n  display: flex;\n  flex: 1 1 var(--v-card-height, 100%);\n  flex-direction: column;\n}\n.v-dialog--scrollable > .v-overlay__content > .v-card > .v-card-text,\n.v-dialog--scrollable > .v-overlay__content > form > .v-card > .v-card-text {\n  backface-visibility: hidden;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
